export enum GridSortingEnum {
  ASCENDING = 'ascending',
  DESCENDING = 'descending',
  NONE = 'none',
}

export enum DataTypeEnum {
  STRING = 'string',
  NUMBER = 'number',
  DATA = 'data', //FORMATO DD/MM/YYYY
  COMPONENT = 'component', //COMPONENT
  RADIO = 'radio',
  DROPDOWN = 'dropdown',
  DROPDOWN_DELETE = 'dropdown_delete',
  CHECKBOX = 'checkbox',
  INPUT = 'input',
  NUMBER_GRID = 'number-grid',
  AUTOSPEDIBILE = 'autospedibile',
  COPY = 'copy',
  FIRST_HOUR_FROM = 'first-hour-from',
  FIRST_HOUR_TO = 'first-hour-to',
  SECOND_HOUR_FROM = 'second-hour-from',
  SECOND_HOUR_TO = 'second-hour-to',
  DATA_EDITABLE = 'data-editabled',
  DATA_TIME = 'data-time',
  DELETE_ICON = 'delete-icon',
  LINK = 'link',
  ICON_BUTTON = 'icon_button',
  TOGGLE = 'toggle',
  BUTTON = 'button',
  MULTI_BUTTON = 'multi_button',
  LINK_NUMBER = 'link_number',
  ICON = 'icon',
  ICON_DOT = 'icon_dot',
}

export enum TemplateGridEnum {
  COLUMN_TEMPLATE = 1,
  ROW_TEMPLATE,
}
